import { PATH_ROOT } from "@/constants";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const useLimitsReportBreadcrumb = () => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("reports.navigation.limitsReport") },
    ],
    [t],
  );
};

export { useLimitsReportBreadcrumb };
